import { catchError, filter, ignoreElements, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { ofType } from 'redux-observable-es6-compat';

import { ASetPlayer, TPlayer, TRemote } from '../actions';
import { PlayerStatus } from '../entities';
import { findPlayerContext } from '../queries';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';

const playerListeners = [
  TPlayer.PLAY,
  TPlayer.PAUSE,
  TPlayer.NEXT,
  TPlayer.SHUFFLE
];
export const playerEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => playerListeners.includes(type)),
    mergeMap(({ type }) => restApi.put(`/player/${type.toLowerCase()}?ngsw-bypass=true`)),
    ignoreElements(),
  );

export const playerSyncEpic =  (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TPlayer.SYNC),
    mergeMap(({ type }) => restApi.get(`/player/${type.toLowerCase()}?ngsw-bypass=true`)),
    ignoreElements(),
  );

export const listenPlayerEpic = (action$, _, { sseApi }) =>
  action$.pipe(
    ofType(TRemote.SET_REMOTE),
    filter(({ payload }) => payload),
    switchMap(({ payload }) => sseApi.startStatus(`/sse-status/${payload.id}/${localStorage.getItem('resortId')}?ngsw-bypass=true`)),
    // switchMap(({payload}) => sseApi.start(`/player/status`)),
    filter(Boolean),
    map((data: any) => data.datas ? data.datas : data),
    map<any, PlayerStatus>(status => ({
      ...status,
      isPlaying: status.state === 'PLAYING',
      context: findPlayerContext(status) || 'timeSlot',
      waitList: (status.waitList || []),
      media: status.media || {}
    })),
    map(ASetPlayer),
    // timeoutWith(300000, of(ASetMessage('Player is offline')))
  );

export const playFromContextEpic = (action$, state$, { restApi }) =>
  action$.pipe(
    ofType(TPlayer.PLAY_FROM),
    // map(({payload}) => buildPlayerStatusFrom(payload, state$.value)),
    mergeMap((payload) => restApi.put('/player/play?ngsw-bypass=true', payload)),
    filter(() => !environment.enableDesktopMode),
    map(ASetPlayer),
  );

const volumeListeners = [
  TPlayer.VOLUME_DOWN,
  TPlayer.VOLUME_UP,
];


export const setVolumeEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => volumeListeners.includes(type)),
    mergeMap(({ type }) => restApi.put(`/player/volume/${type.slice(7).toLowerCase()}?ngsw-bypass=true`)),
    ignoreElements(),
  );


export const slideVolumeEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TPlayer.SET_VOLUME),
    mergeMap(volume => restApi.put(`/player/volume/set?ngsw-bypass=true`, volume)),
    ignoreElements(),
  );

const pingListeners = [
  TPlayer.PING,
  TRemote.SET_REMOTE,
];

export const pingEpic = (action$, _, { restApi }) =>
  action$.pipe(
    filter(({ type }) => pingListeners.includes(type)),
    mergeMap(() => restApi.get(`/player/ping`).pipe(
      catchError(err => of())
    )),
    ignoreElements()
  );
